import React, { useMemo } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Sidebar from './components/Sidebar/Sidebar';
import TopBar from './components/TopBar/TopBar';
import AppRoutes from './routes';
import './styles/global.css';
import './styles/layout.css';

function NoAccess() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100%',
      background: 'var(--bg)',
    }}>
      <div style={{
        textAlign: 'center',
        padding: '40px 48px',
        background: 'var(--sur)',
        borderRadius: 'var(--r)',
        border: '1px solid var(--bdr)',
        boxShadow: 'var(--shm)',
        maxWidth: 420,
      }}>
        <div style={{ fontSize: 36, marginBottom: 16 }}>🔒</div>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--tx)', marginBottom: 8 }}>
          Access Restricted
        </div>
        <div style={{ fontSize: 13, color: 'var(--tx2)', lineHeight: 1.6 }}>
          You do not have permission to view this data.
        </div>
        <div style={{ fontSize: 11, color: 'var(--tx3)', marginTop: 12 }}>
          Please contact Acumen to request access.
        </div>
      </div>
    </div>
  );
}

function Shell() {
  const location = useLocation();
  const { operator, D, hasAccess } = useApp();

  const riskCount = useMemo(() => {
    if (!hasAccess) return 0;
    const util = (D.util || []).filter(r => !operator || r.op === operator);
    const byReg = {};
    util.forEach(r => {
      if (!byReg[r.reg]) byReg[r.reg] = { hrs: 0, n: 0 };
      byReg[r.reg].hrs += r.hrs || 0;
      byReg[r.reg].n++;
    });
    return Object.values(byReg).filter(v => v.hrs / v.n < 5).length;
  }, [operator, D, hasAccess]);

  if (!hasAccess) return <NoAccess />;

  return (
    <div style={{ display: 'flex', height: '100vh', width: '100%', overflow: 'hidden', minWidth: 0 }}>
      <Sidebar riskCount={riskCount} />
      <div className="app">
        <TopBar pathname={location.pathname} />
        <AppRoutes />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Shell />
      </AppProvider>
    </BrowserRouter>
  );
}
